import { ApolloQueryResult } from '@apollo/client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IScheduledReport } from 'src/content/main/CustomReport/components/TableScheduledReport';
import reducer from './sidebarToggleSlice';

interface IScheduledReportResponse {
  result: Array<IScheduledReport>;
  page: number;
  limit: number;
  totalRows: number;
  totalPages: number;
}

interface IState {
  isCreate: boolean;
  scheduleReportList: ApolloQueryResult<IScheduledReportResponse>;
  selectedScheduleReport: IScheduledReport | null;
}

export const dataDummy: IScheduledReport[] = [
  {
    id: '2a9f0b19-3f25-4b9d-8a62-8a1c3f7bb4b2',
    name: 'Weekly Sales Report',
    source: 'Object Group',
    deliveryFrequency: 'Weekly',
    lastDelivery: '2025-10-08 09:00',
    nextDelivery: '2025-10-15 09:00',
    dataSource: ['Internal Data Warehouse', 'Sales Database'],
    recipients: ['marketing@company.com', 'sales@company.com']
  },
  {
    id: '7b2e5d5e-8b24-4b8c-9b0c-6e1e3e4e59ab',
    name: 'Daily Customer Support Summary',
    source: 'Object',
    deliveryFrequency: 'Daily',
    lastDelivery: '2025-10-09 06:00',
    nextDelivery: '2025-10-10 06:00',
    dataSource: ['Customer Support DB', 'Feedback API'],
    recipients: ['support@company.com', 'qa@company.com']
  },
  {
    id: 'e8b3a1d2-5b76-4c99-90e4-9c2a8d3f4c11',
    name: 'Monthly Performance Analytics',
    source: 'Online Media',
    deliveryFrequency: 'Monthly',
    lastDelivery: '2025-10-01 10:30',
    nextDelivery: '2025-11-01 10:30',
    dataSource: ['Google Cloud Storage', 'BigQuery Dataset'],
    recipients: ['ceo@company.com', 'data.team@company.com']
  },
  {
    id: '4d7c5f66-b8b3-4ad9-9e6b-23df12a9c85d',
    name: 'Quarterly Financial Report',
    source: 'Broadcast & Print Media',
    deliveryFrequency: 'Quarterly',
    lastDelivery: '2025-07-01 14:00',
    nextDelivery: '2025-10-01 14:00',
    dataSource: ['Finance System', 'Accounting Ledger'],
    recipients: ['finance@company.com', 'board@company.com']
  },
  {
    id: '8e2a4a1c-3b8d-4e2f-b79b-32a7d2f1e2d9',
    name: 'Social Media Engagement Report',
    source: 'Social Media',
    deliveryFrequency: 'Weekly',
    lastDelivery: '2025-10-07 08:00',
    nextDelivery: '2025-10-14 08:00',
    dataSource: ['Social API', 'TikTok Analytics'],
    recipients: ['social@company.com', 'analytics@company.com']
  }
];

const initialState: IState = {
  isCreate: false,
  scheduleReportList: {
    data: {
      result: dataDummy,
      page: 1,
      limit: 10,
      totalRows: 0,
      totalPages: 0
    },
    loading: false,
    errors: [],
    networkStatus: 1,
    partial: false
  },
  selectedScheduleReport: null
};

export const customSchedulerReport = createSlice({
  name: 'custom-scheduler-report',
  initialState,
  reducers: {
    reducerUpdateIsCreate: (state: IState, action: PayloadAction<boolean>) => {
      state.isCreate = action.payload;
    },
    reducerUpdateScheduleReportList: (
      state: IState,
      action: PayloadAction<ApolloQueryResult<IScheduledReportResponse>>
    ) => {
      state.scheduleReportList = action.payload;
    },
    reducerUpdateSelectedScheduleReport: (
      state: IState,
      action: PayloadAction<IScheduledReport | null>
    ) => {
      state.selectedScheduleReport = action.payload;
    }
  }
});

export const {
  reducerUpdateScheduleReportList,
  reducerUpdateSelectedScheduleReport,
  reducerUpdateIsCreate
} = customSchedulerReport.actions;

export default customSchedulerReport.reducer;
